import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { combineLatest, map } from 'rxjs';
import { Logger } from 'src/app/@shared';
import { OfferGroupVersionsComponent } from '../offer-group-versions/offer-group-versions.component';
import { Version, VersionService } from '../..';

const log = new Logger('VersionListDialogComponent');

export enum VersionDialogMode {
  MOVE_STORES = 'MOVE_STORES',
  REASSIGN_ORPHANED = 'REASSIGN_ORPHANED',
  PAIR_WITH_EXISTING = 'PAIR_WITH_EXISTING'
}

export interface VersionListDialogData {
  event: string;
  mode: VersionDialogMode;
  excludedVersionIds?: string[];
}

@Component({
  selector: 'version-list-dialog',
  templateUrl: './version-list-dialog.component.html',
  styleUrls: ['./version-list-dialog.component.scss']
})
export class VersionListDialogComponent implements OnInit, OnDestroy {

  search = new FormControl<string>('');
  selectedVersion: Version | null = null;
  displayedColumns = ['select', 'VersionName'];
  viewModel$ = combineLatest([
    this.versionService.offerGroupVersions$,
    this.versionService.isLoading$,
    this.versionService.offerGroupVersionstotalRecords$,
    this.versionService.offerGroupVersionsPage$
  ]).pipe(
    map(([versions, isLoading, totalRecords, page]) => {

      if (versions.length === 0 && page.pageIndex > 0) {
        page.previousPageIndex = 0;
        page.pageIndex = 0;
        this.versionService.offerGroupVersionsPage(page);
        this.versionService.offerGroupVersionsReload();
      }

      return { versions, isLoading, totalRecords, page };
    })
  );

  constructor(
    private versionService: VersionService<Version>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    public dialogRef: MatDialogRef<OfferGroupVersionsComponent>) { }

  ngOnInit(): void {
    log.debug('init');
    this.versionService.offerGroupVersionsReload();
  }

  ngOnDestroy() {
    this.clearSearch();
    this.versionService.resetOfferGroupVersionsPage();
  }

  get dialogTitle(): string {
    switch (this.dialogData.mode) {
      case VersionDialogMode.MOVE_STORES:
        return 'Select Target Version';
      case VersionDialogMode.REASSIGN_ORPHANED:
        return 'Select Version to Reassign Stores';
         case VersionDialogMode.PAIR_WITH_EXISTING:
        return 'Select Version to Pair with';
      default:
        return 'Select Version';
    }
  }

  onSearch(event: any) {
    this.versionService.offerGroupVersionsSearch(event.target.value);
  }

  clearSearch() {
    this.search.setValue('');
    this.versionService.offerGroupVersionsSearch('');
  }

  onSort(sortState: Sort): void {
    this.versionService.offerGroupVersionsSort(sortState);
  }

  onPage(pageEvent: PageEvent): void {
    this.versionService.offerGroupVersionsPage(pageEvent);
  }

  closeDialog() {
    this.dialogRef.close();
  }

  selectVersion(version: Version) {
    this.selectedVersion = version;
  }

  saveData() {
    this.dialogRef.close(this.selectedVersion);
  }

}
